module.exports = __webpack_public_path__ + "static/media/poster_5.5c941027.png";